import { useQuery } from '@tanstack/react-query';

import { isEmpty } from 'lodash';
import { tagsQueries } from 'tags/utils/queries';
import { useTagsContext } from './useTagsContext';

export const useTagsByIds = (ids: string[]) => {
  const { type, fetchTags } = useTagsContext();

  const { data, isFetched, isPending } = useQuery({
    queryKey: tagsQueries.list(type, { ids }),
    queryFn: () => fetchTags({ ids }),
    initialData: [],
    enabled: !isEmpty(ids),
  });

  return { selectedTags: data, isFetched: isFetched || isEmpty(ids), isPending };
};
